import React from 'react';
import { techStack } from '../data/mock';

const TechStackSection = () => {
  const categories = [...new Set(techStack.map((t) => t.category))];

  const getCategoryColor = (category) => {
    const colors = {
      Backend: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400',
      Frontend: 'bg-blue-500/10 border-blue-500/30 text-blue-400',
      Database: 'bg-amber-500/10 border-amber-500/30 text-amber-400',
      DevOps: 'bg-purple-500/10 border-purple-500/30 text-purple-400',
      Infrastructure: 'bg-rose-500/10 border-rose-500/30 text-rose-400',
      Cloud: 'bg-sky-500/10 border-sky-500/30 text-sky-400',
      Security: 'bg-red-500/10 border-red-500/30 text-red-400',
      Blockchain: 'bg-orange-500/10 border-orange-500/30 text-orange-400'
    };
    return colors[category] || 'bg-zinc-500/10 border-zinc-500/30 text-zinc-400';
  };

  return (
    <section className="py-24 bg-zinc-950">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <p className="text-cyan-400 font-mono text-sm mb-2">// TECH STACK</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white">Technologies I Use</h2>
        </div>

        {/* Tech Categories */}
        <div className="space-y-8">
          {categories.map((category) => (
            <div key={category}>
              <h3 className="text-sm font-medium text-zinc-500 uppercase tracking-wider mb-4">
                {category}
              </h3>
              <div className="flex flex-wrap gap-3">
                {techStack
                  .filter((t) => t.category === category)
                  .map((tech) => (
                    <div
                      key={tech.name}
                      className={`px-4 py-2 border rounded-lg font-medium text-sm transition-all hover:scale-105 cursor-default ${getCategoryColor(
                        category
                      )}`}
                    >
                      {tech.name}
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStackSection;
